import axios from "axios";
import { getValidToken } from "../../../utils/authUtils";
const BASE_URL = "project-module/project-logs";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  async (config) => {
    const token = await getValidToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const projectLogApiService = {
  createProjectLog: async (projectLog: any) => {
    try {
      const response = await api.post(`${BASE_URL}`, projectLog);
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  bulkCreateProjectLog: async (projectLogs: any[]) => {
    try {
      const response = await api.post(`${BASE_URL}/bulk`, projectLogs);
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  getProjectLogs: async (routeId: string) => {
    try {
      const response = await api.get(`${BASE_URL}/${routeId}`);
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  getProjectLogById: async (logId: string) => {
    try {
      const response = await api.get(`${BASE_URL}/getById/${logId}`);
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  updateProjectLog: async (logId: string, projectLog: any) => {
    try {
      const response = await api.put(`${BASE_URL}/${logId}`, projectLog);
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  bulkUpdateProjectLog: async (projectLogs: any[]) => {
    try {
      const response = await api.put(`${BASE_URL}/bulk/update-logs`, projectLogs);
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  getProjectLogConfiguration: async (projectId: string) => {
    try {
      const response = await api.get(
        `${BASE_URL}/get-project-logs-configuration/${projectId}`
      );
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  getDataForProjectLog: async (
    projectId: string,
    scheduleId: string,
    vehicleId: string
  ) => {
    try {
      const response = await api.get(
        `${BASE_URL}/get-data-for-project-log/${scheduleId}/${vehicleId}/${projectId}`
      );
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  getDataForProjectViewLog: async (
    projectId: string,
    scheduleId: string,
    vehicleId?: string
  ) => {
    try {
      const url =
        vehicleId !== "undefined"
          ? `${BASE_URL}/get-by-route-and-vehicle/${projectId}/${scheduleId}/${vehicleId}`
          : `${BASE_URL}/get-by-route-and-vehicle/${projectId}/${scheduleId}`;
      const response = await api.get(url);
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  getProjectLogsDataForAllSchedules: async (projectId: string) => {
    try {
      const response = await api.get(
        `${BASE_URL}/get-project-logs-data-for-all-schedules/${projectId}`
      );
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
};

export const superProjectLogApiService = {
  getSuperProjectLogConfiguration: async (projectId: string) => {
    try {
      const response = await api.get(
        `${BASE_URL}/get-super-project-logs-configuration/${projectId}`
      );
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  getDataForSuperProjectViewLog: async (
    projectId: string,
    vehicleId?: string
  ) => {
    try {
      const url = `${BASE_URL}/get-logs-by-vehicle/${projectId}/${vehicleId}`;
      const response = await api.get(url);
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
  getDataForSuperProjectLog: async (projectId: string, vehicleId: string) => {
    try {
      const response = await api.get(
        `${BASE_URL}/get-data-for-super-project-log/${projectId}/${vehicleId}`
      );
      if (response.data.isSuccess) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw null;
    }
  },
};
